// Assembly as a scanner tool: the workflow, the untracked-boards switch that only
// Assembly reads, and the session's pair count.

import React from 'react';
import AssemblyWorkflow from './AssemblyWorkflow';
import { FOCUS, MOTION } from '../../Requisitions/buttonStyles';
import { WarningIcon } from '../icons';
import type { ToolContext } from '../types';

/** Sits in the tool bar. The state is a word, and the tint only reinforces it. */
export const UntrackedBoardsSwitch: React.FC<{ ctx: ToolContext }> = ({ ctx }) => {
  const on = ctx.allowUntrackedBoards;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      onClick={() => ctx.setAllowUntrackedBoards(!on)}
      className={`relative inline-flex h-9 shrink-0 items-center gap-2 whitespace-nowrap rounded-full pl-3 pr-1.5 text-sm font-medium np-state
        before:absolute before:-inset-y-1 before:inset-x-0 before:content-['']
        ${on ? 'bg-amber-900/50 text-amber-200' : 'bg-surface-container-high text-on-surface-variant'} ${FOCUS} ${MOTION}`}
    >
      Untracked boards
      <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${on ? 'bg-amber-300 text-amber-950' : 'bg-surface-container-highest text-on-surface-variant'}`}>
        {on ? 'Allowed' : 'Off'}
      </span>
    </button>
  );
};

const AssemblyScreen: React.FC<{ ctx: ToolContext }> = ({ ctx }) => (
  <>
    {ctx.allowUntrackedBoards && (
      <p className="mx-4 mt-1 flex items-start gap-2 rounded-lg bg-amber-900/40 px-3 py-2 text-sm leading-snug text-amber-200">
        <WarningIcon className="mt-px h-4 w-4 shrink-0" />
        <span>Boards with no record will pair too. Turn this off when you are done.</span>
      </p>
    )}
    <div className="flex-1">
      <AssemblyWorkflow
        onPairComplete={ctx.onPairComplete}
        operatorId={ctx.operatorId}
        allowUntrackedBoards={ctx.allowUntrackedBoards}
      />
    </div>
    <p className="px-4 py-3 text-center text-xs text-on-surface-variant bg-surface-container-low">
      Pairs this session: <span className="font-mono tabular-nums text-on-surface">{ctx.pairsCompleted}</span>
    </p>
  </>
);

export default AssemblyScreen;
